import http from "../httpService";
import {getBaseUrl} from "../../config";

export const getReservationInfo = (id) => {
  return http.get(
    `${getBaseUrl()}/reservation_info/${id}`,
  );
};

export const getAgentReservations = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/agent_reservations`,
    );
  }
  return http.get(
    `${getBaseUrl()}/agent_reservations?${paginate}`,
  );
};

export const getUserReservations = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/user_reservations`,
    );
  }
  return http.get(
    `${getBaseUrl()}/user_reservations?${paginate}`,
  );
};

export const getAgentMonthReservations = (agentId, jy, jm, monthDays) => {
  return http.get(
    `${getBaseUrl()}/agent_month_reservations/${agentId}/${jy}/${jm}/${monthDays}`,
  );
};

export const getFinishedReservation = (paginate) => {
  return http.get(
    `${getBaseUrl()}/finished_reservations?${paginate}`,
  );
};

export const updateUserReservation = data => {

  return http.put(
    `${getBaseUrl()}/user_reservation/${data.id}`,
    data
  );
};

export const updateReservationFinish = data => {

  return http.put(
    `${getBaseUrl()}/finish_reservation/${data.id}`
  );
};

export const updateReservationCancel = data => {

  return http.put(
    `${getBaseUrl()}/cancel_reservation/${data.id}`
  );
};

export const submitUserReservation = data => {

  return http.post(
    `${getBaseUrl()}/user_reservation`,
    data
  );
};
